import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useState } from "react";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import { ModalsProvider } from "./components/common/ModalsProvider.js";
import { ThemeProvider, applyStoredTheme } from "./components/theme/ThemeProvider.js";
import { I18nProvider } from "./i18n/index.js";
import { LocaleSyncFromAuth } from "./i18n/LocaleSyncFromAuth.js";
import { bootstrapImpersonationFromHash } from "./lib/impersonation.js";
import { trpc } from "./lib/trpc.js";
import { createTrpcClient } from "./lib/trpc-client.js";
import "./index.css";

function Root() {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 30_000,
            retry: 1,
            refetchOnWindowFocus: false,
          },
        },
      }),
  );
  const [trpcClient] = useState(() => createTrpcClient());

  return (
    <ThemeProvider>
      <I18nProvider>
        <trpc.Provider client={trpcClient} queryClient={queryClient}>
          <QueryClientProvider client={queryClient}>
            <ModalsProvider>
              <LocaleSyncFromAuth />
              <App />
            </ModalsProvider>
          </QueryClientProvider>
        </trpc.Provider>
      </I18nProvider>
    </ThemeProvider>
  );
}

// Aplica o tema salvo ANTES do 1º paint (evita flash claro→escuro).
applyStoredTheme();
// F-impersonate-tab — captura o token #imp= ANTES do 1º request tRPC.
bootstrapImpersonationFromHash();

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Root element #root not found in index.html");

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>,
);
